
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/coupons",
      function () {
        return require("private-next-pages/user/coupons/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/coupons"])
      });
    }
  